import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SortService } from './sort.service';

@Component({
	selector: '[sortable-column]',
	templateUrl: './sortable-column.component.html',
	
})
export class SortableColumnComponent implements OnInit, OnDestroy {

	constructor(private sortService: SortService) { }

	@Input('sortable-column')
	columnName: string;

	@Input('sort-direction')
	sortDirection: string = '';

	private columnSortedSubscription: Subscription;

	@HostListener('click')
	sort() {
		this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		this.sortService.columnSorted({ sortColumn: this.columnName, sortDirection: this.sortDirection });
	}

	ngOnInit() {
		// subscribe to sort changes so we can react when other columns are sorted
		this.columnSortedSubscription = this.sortService.columnSorted$.subscribe(event => {
			// reset this column's sort direction to hide the sort icons
			if (!event || this.columnName != event.sortColumn) {
				this.sortDirection = '';
			} else {
				if (!this.sortDirection) {
					this.sortDirection = event.sortDirection;
				}
			}
		});
	}

	ngOnDestroy() {
		if (this.columnSortedSubscription) {
			this.columnSortedSubscription.unsubscribe();
		}
	}



}
